import React from 'react';
import {
  TableContainer,
  TableHead,
  TableBody,
  TableBodyRow,
  TableHeadCell,
} from '../../../../../../../components/tableComponents';

export const housesTableComponents = {
  table: TableContainer,
  header: {
    wrapper: TableHead,
    cell: TableHeadCell,
  },
  body: {
    wrapper: TableBody,
    row: (props) => <TableBodyRow isClickable {...props} />,
  },
};
